export default "__VITE_ASSET__w1KteWkM__"